﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function citiesPage() {

    const navLinks = document.querySelectorAll('#citiesList a');
    let innerHeightTop;
    let innerHeightBottom;
    let yOffset = -30;

    function updateActiveLinks() {
        navLinks.forEach(link => {
            const sectionId = link.getAttribute('href');
            const sections = document.querySelectorAll(sectionId);

            sections.forEach(section => {

                //phone
                if (window.innerWidth <= 480) {
                    innerHeightTop = 0.1;
                    innerHeightBottom = 0.04;
                }
                //tablet
                else if (window.innerWidth <= 768) {
                    innerHeightTop = 0.07;
                    innerHeightBottom = 0.04;

                }
                //laptop
                else if (window.innerWidth <= 988) {
                    innerHeightTop = 0.15;
                    innerHeightBottom = 0.05;
                    yOffset = -10;
                }
                else {
                    innerHeightTop = 0.07;
                    innerHeightBottom = 0.05;
                    yOffset = -10;
                }

                if (section.parentElement.getBoundingClientRect().top <= window.innerHeight * innerHeightTop && section.parentElement.getBoundingClientRect().bottom > window.innerHeight * innerHeightBottom) {
                    link.classList.add('citiespage__navigation__list--active');
                } else {
                    link.classList.remove('citiespage__navigation__list--active');
                }
            });
        });

        // Check if user has reached the bottom of the page
        if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
            navLinks.forEach(link => {
                link.classList.remove('citiespage__navigation__list--active');
            });
            navLinks[navLinks.length - 1].classList.add('citiespage__navigation__list--active');
        }
    }

    window.addEventListener('scroll', updateActiveLinks);

    navLinks.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();

            const targetId = link.getAttribute('href');

            const targetElement = document.querySelector(targetId);


            const positionY = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({ behavior: 'smooth', top: positionY });

            // Update active links after scrolling to target element
            setTimeout(() => {
                updateActiveLinks();
            }, 1000);
        });
    });
}



controller.add('cities-page', citiesPage);